import { SeriesMeta } from "../view/series-meta";
import { Identifiable } from "./identifiable";
import { SeriesElement } from "./SeriesElement";

export class Series implements Identifiable {

    id: string;
    description: string;
    date: string;
    time: string;
    modality: string;
    bodyPart: string;
    data: Map<string, SeriesElement>;

    constructor(seriesElement: SeriesElement) {
        this.id = seriesElement.getSeriesId();
        this.description = seriesElement.getSeriesDescription();
        this.date = seriesElement.getSeriesDate();
        this.time = seriesElement.getSeriesTime();
        this.modality = seriesElement.getSeriesModality();
        this.bodyPart = seriesElement.getSeriesBodyPart();
        this.data = new Map();
    }

    getId(): string {
        return this.id;
    }

    addSeriesElement(e: SeriesElement) {
        let seriesElement: SeriesElement | undefined = this.data.get(e.getId());
        if (!seriesElement) {
            this.data.set(e.getId(), e);
        } else {
            // TODO Error or ??
        }
    }

    getDescription(): string {
        return this.description;
    }

    getDate(): string {
        return this.date;
    }

    getTime(): string {
        return this.time;
    }

    getModality(): string {
        return this.modality;
    }

    getBodyPart(): string {
        return this.bodyPart;
    }

    convert(): SeriesMeta {
        return {
            id: this.id,
            description: this.description,
            date: this.date,
            time: this.time,
            modality: this.modality,
            bodyPart: this.bodyPart
        };
    }
}
